import axios from "axios";

export function getFips() {
  return axios.get("/User/fip");
}

export function getFiufromHandleId(handleId: string) {
  return axios.get(`/User/fiu/${handleId}`);
}
